import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {
  private history: string[] = [];
  private readonly MAX_HISTORY_LENGTH = 15; // Store only the last 15 entries

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      const storedHistory = sessionStorage.getItem('navigationHistory');
      if (storedHistory) {
        try {
          this.history = JSON.parse(storedHistory) || [];
          if (this.history.length > 0) {
            this.history.splice(this.history.length - 1, 1); 
          }
        } catch (error) {
          // If storedHistory is not valid JSON, clear it and start fresh
          console.warn('Invalid navigation history format, clearing stored history:', error);
          this.history = [];
        }
        sessionStorage.removeItem('navigationHistory');
      }
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.addToHistory(event.urlAfterRedirects);
        }
      });

      window.addEventListener('beforeunload', this.handleBeforeUnload.bind(this));
    }
  }

  private addToHistory(url: string): void {
    this.history.push(url);

    if (this.history.length > this.MAX_HISTORY_LENGTH) {
      this.history.shift();
    }
  }

  private handleBeforeUnload(): void {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('navigationHistory', JSON.stringify(this.history));
    }
  }

  // Get all the past navigation history
  getHistory(): string[] {
    return isPlatformBrowser(this.platformId) ? [...this.history] : [];
  }

  // Get the last visited route
  getLastRoute(): string | null {
    return isPlatformBrowser(this.platformId) && this.history.length > 1
      ? this.history[this.history.length - 2]
      : null;
  }

  // Clear history (optional)
  clearHistory(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.history = [];
      sessionStorage.removeItem('navigationHistory');
    }
  }
}
